export interface ProductSize {
	Id: number | null;
	Name: string;
	ProductTypeId: number | null;
	ProductTypeName: string | null;
	SectionCode: string;
	Description: string;
	SpecialMillComments: string;
	Weight: number | null;
	Active: boolean;
	FinishSpeedGoal: number | null;
	Stand1GapGoal: number | null;
	Stand17GapGoal: number | null;
	TPHGoal: number | null;
	Dim1: number | null;
	Dim2: number | null;
	Dim3: number | null;
	RevisionTimestamp: string | null;
	RevisionUserName: string | null;
}

export const PRODUCT_SIZE_INITIAL_VALUES: ProductSize = {
	Id: null,
	Name: "",
	ProductTypeId: null,
	ProductTypeName: null,
	SectionCode: "",
	Description: "",
	SpecialMillComments: "",
	Weight: null,
	Active: true,
	FinishSpeedGoal: null,
	Stand1GapGoal: null,
	Stand17GapGoal: null,
	TPHGoal: null,
	Dim1: null,
	Dim2: null,
	Dim3: null,
	RevisionTimestamp: null,
	RevisionUserName: null,
};

export interface ProductTypeOption {
	Id: number;
	Name: string;
}
